var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRiskCase1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 129,
    viewBox: "0 0 127 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1704_3339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 31.1047C10 19.4489 19.4489 10 31.1047 10H87.2758C98.9317 10 108.381 19.4489 108.381 31.1047V88.8953C108.381 100.551 98.9317 110 87.2758 110H31.1047C19.4489 110 10 100.551 10 88.8953V31.1047Z",
    fill: "#FBF8F0"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 30,
    width: 60,
    height: 60,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1704_3339",
    x: 0.151122,
    y: 0.151122,
    width: 126.52,
    height: 128.14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 7.03491,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1704_3339"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.22095,
    dy: 4.22095
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.51746
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1704_3339"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1704_3339",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1704_3339",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1704_3339",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAADOUlEQVR4nO2czYoUMRSFj389vsO8RWpR8wz+z4iI76Cz1aULNwqi4N6Nim/i6EoREUFFRt0qLTODgmAkkAYtuqcryb2dSup8kF33pO75cpOurqEBQgghhBBCCKmf6wCs4CCZJZDMEkhmCVXS+rEKblLA/zQAvgOYAtjA8DuhyvCtHyVIqIbWB94tcLqi7cjN8XOsAprOyp8nYSPj/FULaHoWryUhJfziBTSBxUtLSA2/aAFNZPFSEiTCt7UduDZAQrui+X/VJkBq5U0jOyFk/pnowz6ijjJ8GykhJvwZiyQUQ0jbTwNf2yrM3/b82qIIYlaeAfBNqBNSVn6XbicMnpTijYAEyfDnSRg0EsWbBAka4XclDBaJPTflb0nOvwh3JgwSjeLbzId4MWi2vQnYjhi+0sozQhK48hFPqgSGnxB+qgSGDzlMoITqwnfcyFx82/MTT5Xh932grV28WdIJVYe/TMKqijcLJIwi/EUSVl286UgYVfhdCbmKN17CKMP/92BuR/KvjYQQQgghhBAijtTjv7GOZHIXYAsfFAAKyL4KLTsgfxCWW1D+MGyGwTMAFJB9FdqxdcAP1MdeSQJ2UB8vShJwFTocA7AF4DGANwB+AzgA8BrAUwDnAJxQmvtaKQJeAphAnjMAPvWY/wuAUwrzr/naBi3AXeA6ZDkC4A6APwHX4V57179XkvUICcksm8AdTs/8tqOx8m9Ftr4btxWuZ+Jr3el5MCejPsEhXAhc+fPGaehSrYDjAN4lhu/GB79/a1GtgMsC4c/GecXrrFbAQ0EBTxSvs1oBHwUFfFa8zmoFHAgKcD85owUFYHkI7sf4KCCQXcEOcHfQFBDII0EB7kCngEDOCgq4RAFxt/xfBcJ3W9lJCohjS0DAJnTJ/iloH8Bz/325xi3/vYTw3XulcTVu+5r3hyBA++voowAeRIR/379XElfbq8DrSMZGSNDohM2eD2R2lbadtYjwswjQfCQ5AXDFf7fz3m8B7i73rX8keVHxwN2OzCKZmEn5UB55BbgnRbWxV1IHcIAC7EAWAjsAFJB9FVp2QP4gLLeg/GHYDINnACgg+yq0JXcAIYQQQgghBFXxF376JeCUsQ+RAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskCase1);
export default __webpack_public_path__ + "static/media/RiskCase1.fe403fd0ed1bc3f7152dd866b57ebbcc.svg";
export { ForwardRef as ReactComponent };